// extracted by mini-css-extract-plugin
module.exports = {"Heading":"Heading_Heading__HXmpr"};